<template>
    <div>
        <!-- <div>项目云盘</div> -->
        <div class="tishi">
            功能说明：与项目相关的一些文件可以上传到这里备份保存，解放你的电脑容量🎉
        </div>
        <div class="upload_div">
            <div class="capacity_div">
                <div>
                    {{ capacity }} <span>GB</span>
                </div>
                <div class="capacity_txt">
                    已使用
                </div>
            </div>
            <!-- <div class="file_img1_div2">
                <div class="file_img1_div">
                    <img src="@/assets/image/cloud/file_add.png" alt="" class="file_img1" />
                </div>
                <div>
                    新建文件夹
                </div>
            </div> -->
            <Upload :show-upload-list='false' class="upload_div2" multiple type="drag" v-if="upload_url"
                :action="upload_url + '&folder_id=' + current_folder_id" :before-upload='before_upload'
                :on-progress="on_progress" :on-success='on_success'>
                <div class="upload_div3">
                    <Button icon="ios-cloud-upload-outline">点击或拖拽到此处上传文件</Button>
                </div>
            </Upload>
        </div>

        <div ref="myElementRef" class="elementui_div">
            <div class="back_2">
                <div style="margin-right: 10px;">
                    <Button @click="back_folder">返回</Button>
                </div>
                <div class="mbx_div">
                    <div v-for="(item, i) in folder_name_list" :key="i">
                        <span>{{ item }}</span>
                        <span v-if="i < folder_name_list.length - 1">&nbsp;/&nbsp;</span>
                    </div>
                </div>
            </div>
            <div @contextmenu="onContextMenu2($event)" class="max_empty">
                <div class="img_div_list">

                    <div class="file_img_div" v-for="(item, i) in file_list" @dblclick="click_floder(item, i)"
                        @contextmenu="onContextMenu($event, item)">
                        <div class="file_img_1" v-if="item.type == 'folder'">
                            <img src="@/assets/image/cloud/file.png" alt="" class="file_img" />
                        </div>
                        <div v-else>
                            <div class="file_img_1" v-if="office_file_dict[item.file_content_type] == 'excel'">
                                <img src="@/assets/image/cloud/excel.png" alt="" style="width:40px;height: 40px;" />
                            </div>
                            <div class="file_img_1" v-else-if="office_file_dict[item.file_content_type] == 'word'">
                                <img src="@/assets/image/cloud/word.png" alt="" style="width:40px;height: 40px;" />
                            </div>
                            <div class="file_img_1" v-else-if="office_file_dict[item.file_content_type] == 'ppt'">
                                <img src="@/assets/image/cloud/ppt.png" alt="" style="width:40px;height: 40px;" />
                            </div>
                            <div class="file_img_1" v-else-if="office_file_dict[item.file_content_type] == 'pdf'">
                                <img src="@/assets/image/cloud/pdf.png" alt="" style="width:40px;height: 40px;" />
                            </div>
                            <div class="file_img_1" v-else-if="office_file_dict[item.file_content_type] == 'zip'">
                                <img src="@/assets/image/cloud/zip.png" alt="" style="width:40px;height: 40px;" />
                            </div>
                            <div class="file_img_1" v-else-if="office_file_dict[item.file_content_type] == 'img'">
                                <img src="@/assets/image/cloud/img.png" alt="" style="width:40px;height: 40px;" />
                            </div>
                            <div class="file_img_1" v-else>
                                <img src="@/assets/image/cloud/txt.png" alt="" style="width:40px;height: 40px;" />
                            </div>
                        </div>
                        <div class="folder_txt" :title="item.file_name">
                            {{ item.file_name }}
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- <div>
            <Table size="small" :columns="columns" :data="file_list" :height="windowHeight - 260">
                <template #action="{ row }">
                    <span class="down_span" @click="download_file(row)">查看</span>
                    <span class="del_span" @click="del_file(row)">删除</span>
                </template>
</Table>
</div> -->

        <Modal v-model="add_folder_show" title="创建新文件夹" :mask-closable="false" :footer-hide="true" width="300">

            <div>
                <Input v-model="new_folder_name" placeholder="请输入文件夹名称.." style="width: 270px" />
            </div>
            <div class="new_folder_btn">
                <Button type="primary" @click="add_new_folder">确认添加</Button>
            </div>
        </Modal>


        <Modal v-model="upload_show" title="上传文件" :mask-closable="false" :footer-hide="true" width="400">
            <div>
                正在上传中，上传成功此窗口会自动关闭
            </div>
            <Circle :percent="percent">
                <Icon v-if="percent == 100" type="ios-checkmark" size="60" style="color:#5cb85c"></Icon>
                <span v-else style="font-size:24px">{{ percent }}%</span>
            </Circle>
        </Modal>

    </div>
</template>

<script>
import { get_view_file_url, http, open_new_page } from "@/utils/http.js";

export default {
    name: "cloud_disk",
    data() {
        return {
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度
            project_id: "",
            upload_url: "",
            page: 1,
            file_list: [],
            columns: [],
            upload_show: false,
            percent: 0,
            capacity: "",

            menuVisible: false,
            current_folder_id: "",
            folder_name_list: ['根目录'],
            folder_id_list: [''],
            add_folder_show: false,
            new_folder_name: "",

            // folder_data_list: ['文件夹1', '文件夹2'],
            office_file_dict: {

                'application/vnd.ms-excel': 'excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'excel_template',

                'application/msword': 'word',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'word',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'word_template',

                'application/vnd.ms-powerpoint': 'powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml.template': 'powerpoint_template',
                'application/vnd.openxmlformats-officedocument.presentationml.slideshow': 'powerpoint_slideshow',

                'application/pdf': 'pdf',

                'text/plain': 'txt',
                'text/csv': 'txt',
                'text/rtf': 'txt',
                'application/zip': 'zip',
                'application/x-zip-compressed': 'zip',
                'application/zip-compressed': 'zip',

                'application/x-rar-compressed': 'zip',
                'application/vnd.rar': 'zip',
                'application/x-rar': 'zip',

                'application/x-7z-compressed': 'zip',
                'application/x-7z': 'zip',
                'image/jpeg': 'img',
                'image/jpg': 'img',
                'image/png': 'img',
                'image/gif': 'img',
                'image/webp': 'img',
                'image/bmp': 'img',
                'image/tiff': 'img',
                'image/svg+xml': 'img',
                'image/x-icon': 'img',
                'image/vnd.microsoft.icon': 'img',


            },
            folder_list: [],

        }
    },
    mounted() {

    },

    methods: {


        //点击右键
        onContextMenu2(e) {
            e.preventDefault(); // 阻止默认右键菜单的显示
            console.log('空白地方右键')
            var that = this
            this.$contextmenu({
                x: e.x,
                y: e.y,
                items: [
                    {
                        label: "创建新文件夹",
                        onClick: () => {
                            that.add_folder_show = true
                            console.log(this.current_folder_id)
                        }
                    },

                ]
            });
        },

        //点击右键
        onContextMenu(e, item) {
            console.log(123, item)
            e.stopPropagation(); // 阻止事件冒泡到容器

            var file_id = item.id
            var that = this
            //prevent the browser's default menu
            e.preventDefault();
            //show our menu
            var folder_list = this.folder_list
            var move_child_list = []
            for (var i = 0; i < this.folder_list.length; i++) {
                console.log(folder_list[i])
                var filename = this.folder_list[i]['file_name']
                let folder_id = this.folder_list[i]['folder_id']
                console.log(folder_id)
                move_child_list.push(
                    {
                        label: filename, onClick: (e) => {
                            console.log('移动', e, folder_id)
                            that.move_file(folder_id, file_id)
                        }
                    }
                )
            }
            console.log(move_child_list)
            this.$contextmenu({
                x: e.x,
                y: e.y,
                items: [
                    {
                        label: "创建新文件夹",
                        onClick: () => {
                            that.add_folder_show = true
                            console.log(this.current_folder_id)
                        }
                    },
                    {
                        label: "移动至文件夹",
                        children: move_child_list

                    },
                    {
                        label: "下载(查看)",
                        onClick: () => {

                            that.download_file(item)
                        }

                    },
                    {
                        label: "删除",
                        onClick: () => {
                            that.del_file(item)
                        }

                    },
                ]
            });
        },


        add_new_folder() {
            var that = this;
            var obj = {
                project_id: this.project_id,
                folder_id: this.current_folder_id,
                name: this.new_folder_name
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/cloud_disk/add_folder",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.get_file_list()
                        that.add_folder_show = false
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },


        on_success(e) {
            this.upload_show = false
            if (e.code == 0) {
                this.$Message.success(e.msg)
                this.get_file_list()

            } else {
                this.$Message.error(e.msg)
            }
        },
        on_progress(e) {
            console.log(e)
            this.percent = Math.round(e.percent)

        },
        before_upload() {
            this.upload_show = true

        },
        del_file_request(item) {
            var that = this;
            var obj = {
                id: item.id,
                file_type: item.type
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/cloud_disk/file_del",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.get_file_list()
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        del_file(item) {
            this.$Modal.confirm({
                title: '提示',
                content: '<p>正在删除，删除后无法恢复，是否继续？</p>',
                onOk: () => {
                    this.del_file_request(item)
                },
                onCancel: () => {
                }
            });
        },


        move_file(folder_id, file_id) {
            var that = this;
            var obj = {
                project_id: this.project_id,
                folder_id: folder_id,
                id: file_id
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/cloud_disk/move_to_folder",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_file_list()

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        get_file_list() {
            var that = this;
            var obj = {
                page: this.page,
                project_id: this.project_id,
                folder_id: this.current_folder_id
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/cloud_disk/file_list",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.file_list = res.data.data_list
                        that.columns = res.data.columns
                        that.capacity = res.data.capacity
                        that.folder_list = res.data.folder_list

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        open(project_id) {
            console.log("打开", project_id)
            this.project_id = project_id
            this.current_folder_id = ''
            this.upload_url = process.env.VUE_APP_HOST +
                "/my_project/cloud_disk/upload_file?token=" +
                this.$cookies.get("dx_token") + '&project_id=' + this.project_id
            this.get_file_list();
        },

        download_file(item) {
            console.log(item)
            get_view_file_url(item.file_object)
        },
        click_floder(item, i) {
            console.log('双击', item)
            this.current_folder_id = item.folder_id
            this.get_file_list();
            if (item.type == 'folder') {
                this.folder_name_list.push(item.file_name)
                this.folder_id_list.push(item.folder_id)
            } else {
                this.download_file(item)
            }

        },
        back_folder() {
            // 删除最后一个元素并校验
            if (this.folder_name_list.length <= 1) {
                return
            }
            // 删除最后一个元素
            this.folder_name_list.pop();
            this.folder_id_list.pop()
            this.current_folder_id = this.folder_id_list[this.folder_id_list.length - 1]
            this.get_file_list()

        },



    }
}
</script>

<style scoped>
.new_folder_btn {
    display: flex;
    justify-content: end;
    margin: 20px 0 0 0
}

.back_2 {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #f0f0f0;
}

.mbx_div {
    display: flex;
    align-items: center;
    color: #ccc;
}

.elementui_div {
    height: calc(100vh - 260px);
}

.folder_txt {
    word-wrap: break-word;
    width: 100px;
    display: flex;
    justify-content: center;
    color: #888;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 设置宽度 */
    display: block;
    text-align: center;
}





.file_img_1 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;

}

.file_img1_div {
    display: flex;
    align-items: center;
    justify-content: center;
}

.file_img1_div2 {
    padding: 5px 10px;
    border-radius: 5px;
    /* margin: 0 0 0 20px; */
    /* padding-top: 15px; */
}

.max_empty {
    width: 100%;
    height: calc(100% - 30px);
}

.file_img1_div2:hover {
    cursor: pointer;
    color: #fff;
    background-color: #5bdda4;
}

.img_div_list {
    display: flex;
    flex-wrap: wrap;
}

.file_img_div {
    align-items: center;
    margin: 0 5px 10px 0;
    padding: 10px;
    border-radius: 5px;
}

.file_img_div:hover {
    cursor: pointer;
    background-color: #f5f4f4;
}

.file_img_suffix {
    width: 60px;
    height: 60px;
}

.file_img {
    width: 60px;
    height: 60px;
}

.file_img1 {
    width: 50px;
    height: 50px;
}

.tishi {
    padding: 5px;
    background-color: #fdffe2;
    margin-bottom: 10px;
    color: #525252;
    border: 1px solid #f4f2f2;
    border-radius: 5px;
}

.capacity_txt {
    margin-top: 5px;
    font-size: 14px;
    color: #fff;
}

.capacity_div {
    font-size: 16px;
    font-weight: 600;
    width: 100px;
    height: 80px;
    background-color: #00b365;
    border-radius: 5px;
    color: #fff;
    margin: 0 20px 10px 0;
    padding: 15px 10px 0 10px;
}

.del_span {
    color: red;
    cursor: pointer;
    margin-left: 5px;
}

.down_span {
    cursor: pointer;
    color: #1065cd
}

.upload_div {
    display: flex;
    height: 90px;
}

.upload_div3 {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload_div2 {
    width: 100%;
    height: 100px;
}
</style>